<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('question.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('question.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <staff-question v-if="isStaff" />
  </div>
</template>

<script>
import StaffQuestion from './staff/index'

export default {
  name: 'question',
  components: {
    StaffQuestion
  },
  data() {
    return {}
  },
  computed: {
    isStaff() {
      return this.$store.getters.isStaffLogin
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('eschool/eExam/question/RESET_STATE')
    next()
  }
}
</script>
